import React from 'react';
import { Check, X } from 'lucide-react';

const forYouItems = [
  'You want structure and accountability',
  "You're done guessing what to do",
  'You want sustainable progress',
  'You can commit consistently'
];

const notForYouItems = [
  'You want a quick fix',
  "You don't want to follow a plan",
  "You're looking for free advice",
  "You aren't ready to invest"
];

const ForYouSection = () => {
  return (
    <section className="py-16 sm:py-24 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 uppercase tracking-wider">
            Is This Right for You?
          </h2>
          <p className="text-white/50 text-sm sm:text-base max-w-md mx-auto">
            Honest coaching requires honest expectations
          </p>
        </div>

        {/* Content */}
        <div className="max-w-3xl mx-auto">
          {/* Two Columns */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            {/* This Is For You */}
            <div className="section-card border-white/30 bg-white/5">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 bg-white flex items-center justify-center">
                  <Check className="w-5 h-5 text-black" />
                </div>
                <h3 className="text-lg font-bold text-white uppercase tracking-wider">For You If</h3>
              </div>
              <ul className="space-y-3">
                {forYouItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <Check className="w-4 h-4 text-white mt-0.5 flex-shrink-0" />
                    <span className="text-white/70 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* This Is NOT For You */}
            <div className="section-card">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 bg-white/10 flex items-center justify-center">
                  <X className="w-5 h-5 text-white/50" />
                </div>
                <h3 className="text-lg font-bold text-white uppercase tracking-wider">Not For You If</h3>
              </div>
              <ul className="space-y-3">
                {notForYouItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <X className="w-4 h-4 text-white/40 mt-0.5 flex-shrink-0" />
                    <span className="text-white/50 text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForYouSection;
